export const StreamingFilterBlockConstant = "streaming";
//# sourceMappingURL=filterBlockConstants.js.map